import { render, staticRenderFns } from "./ReportByProductByMonthTable.vue?vue&type=template&id=966dab10&scoped=true&"
import script from "./ReportByProductByMonthTable.vue?vue&type=script&lang=js&"
export * from "./ReportByProductByMonthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966dab10",
  null
  
)

export default component.exports